import { render, staticRenderFns } from "./comp_UserOrderDetail-PaymentInstructions.vue?vue&type=template&id=2b5f6ce5&"
import script from "./comp_UserOrderDetail-PaymentInstructions.vue?vue&type=script&lang=js&"
export * from "./comp_UserOrderDetail-PaymentInstructions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports